<template>
  <v-dialog v-model="visible" max-width="4in">
    <v-card>
      <v-card-text>
        <h1>Import</h1>
        <p>QuickChords can import and translate documents from a variety of sources.<br/>Let's start by picking a
          method.</p>
        <v-btn-toggle v-model="toggle" style="flex-direction: column">
          <v-btn @click="mode='external'">Search An External Service</v-btn>
          <v-btn @click="onPasteMode">Paste A Link Or Text</v-btn>
          <v-btn @click="onUploadMode">Upload A PDF</v-btn>
        </v-btn-toggle>

        <hr v-if="mode" style="margin: 2em"/>

        <template v-if="mode === 'paste'">
          <p>Paste your link or text into the following text area.</p>
          <p>We accept links from iRealb and iRealPro. You can also copy/paste Ultimate Guitar Lyrics+Chords.</p>
          <v-textarea ref="textArea" box class="ta"></v-textarea>
          <v-btn @click="onImportPaste">Import</v-btn>
        </template>

        <template v-if="mode === 'external'">
          <div style="display: flex; flex-direction: column; align-items: center">
            <p>Now pick a service:</p>
            <v-btn @click="onSearchUG">Ultimate Guitar - Chords</v-btn>
            <v-btn @click="onSearchWikia">Wikia - Lyrics</v-btn>
          </div>
        </template>

        <template v-if="mode === 'upload'">
          <div style="display: flex; flex-direction: column; align-items: center">
            <p>Any PDF will do.</p>
            <v-btn @click="onImportFile">Select A PDF...</v-btn>
          </div>
        </template>

      </v-card-text>
    </v-card>
    <WikiaSearch ref="searchWikia" proxy-url="https://www.quickchords.org:9999"/>
    <UGSearch ref="searchUG" proxy-url="https://www.quickchords.org:9999"/>
  </v-dialog>
</template>

<script>
  import WikiaSearch from "./WikiaSearch";
  import UGSearch from "./UGSearch";
  import QcUtil from '/Users/steven/dev/projects/other/quickchords-vue/src/util/util-qc.js'
  import {getDocumentField} from '/Users/steven/dev/projects/other/quickchords-vue/src/util/document.js'

  export default {
    name: "ImportDialog",
    components: {UGSearch, WikiaSearch},
    data: function () {
      return {
        toggle: null,
        visible: false,
        mode: null,
      }
    },
    props: {},
    methods: {
      show() {
        this.visible = true
      },
      onPasteMode() {
        this.mode = 'paste'
        this.$nextTick(() => {
          this.$refs.textArea.focus()
        })
      },
      onUploadMode() {
        this.mode = 'upload'
        this.$nextTick(() => {
        })
      },
      onImportPaste() {
        this.$snackbar.show('This Feature Is Not Implemented')
      },
      onImportFile() {
        this.$snackbar.show('This Feature Is Not Implemented')
      },
      onSearchUG() {
        this.$refs.searchUG.pickFile().then(res => {
          this._sendEmbeddedDoc(res)
        })
      },
      onSearchWikia() {
        this.$refs.searchWikia.pickFile().then(res => {
          this._sendEmbeddedDoc(res)
        })
      },
      _sendEmbeddedDoc(doc) {
        const params = {
          flavor: getDocumentField('quickchords', doc, 'flavor', 'chords'),
          collection: '0',
          artist: getDocumentField('quickchords', doc, 'artist', 'Unknown'),
          title: getDocumentField('quickchords', doc, 'title', 'Untitled'),
          embed: doc,
        }
        this._sendEmbedded(params)
      },
      _sendEmbedded(params) {
        const url = QcUtil.makeCreatorLink(params)
        window.open(url, '_self')
      },
    }
  }
</script>

<style scoped>
  .ta {
    flex: 1
  }


</style>